import { useEffect } from 'react';
import { useOperations as useAuthOperations } from 'store/features/auth';
import {
  useIsUnknownUser,
  useUserType
} from 'store/features/auth/selectors';
import { useIsAllowDependsOnContour } from 'entities/application';


const useInitPermissions = () => {
  const { getPermissions } = useAuthOperations();
  const isUnknownUser = useIsUnknownUser();
  const userType = useUserType();
  const isAllowDependsOnContour = useIsAllowDependsOnContour();

  useEffect(() => {
    if (isAllowDependsOnContour && !isUnknownUser) {
      getPermissions(userType);
    }
  }, [getPermissions, userType, isAllowDependsOnContour, isUnknownUser]);
};

export default useInitPermissions;
